/**
 * Created by Languagenut on 19/06/2019.
 */

import React  from 'react';
import {Form, Col , Row , Modal , Button} from 'react-bootstrap'
import Select from  'react-select';
import Translation from  '../../store/internationalization-store.js';
import FieldGroup from '../FieldGroup.js';
import Base from './new_staff.js'
import AccountService from '../../services/account-service.js';

export default class TextPopup extends Base {

    constructor(props) {
        super();
        this.props = props;

        console.log(this.props);

        this.state = {
            multiSelect:this.props.data || [],
            value:this.props.value || [],
            password_generation:false
        };
    }

    componentWillReceiveProps(props){
        this.props = props;


        if(this.props.selected)
        {
            this.state = {
                multiSelect:this.props.data || [],
                value:this.props.value || [],
                email:this.props.selected.email,
                first_name:this.props.selected.first_name,
                last_name:this.props.selected.last_name,
                title:this.props.selected.title,
                password_generation:false
            };
        }

    }


    onChange(params) {

        this.setState({
            value:params
        })
    }

    onSave(){

        AccountService.editStaff(this.props.selected.uid , this.state.first_name , this.state.last_name , this.state.email , this.state.value , this.state.title).then(function(){
            if(this.props.onSave) this.props.onSave(this.state.value);
            this.props.onHide();
        }.bind(this))
    }

    optionClicked(optionsList) {
        this.setState({ multiSelect: optionsList });
    }
    selectedBadgeClicked(optionsList) {
        this.setState({ multiSelect: optionsList });
    }

    generate(){
        AccountService.newPassword(this.props.selected.uid).then(function(response){
            this.setState({
                password_generation:response.password
            })
        }.bind(this))
    }

    render() {

        let hint = null;

        if(this.state.password_generation)
        {
            hint = <span>&nbsp;&nbsp;<small><b>New Password:&nbsp;&nbsp;{this.state.password_generation}</b></small></span>
        }

        const {selected} = this.state;
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <div ><Button onClick={this.generate.bind(this)} >{Translation.get(12653, "Select")}</Button>{hint}<br/></div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={2}>
                            <FieldGroup autofocus={true} state={!this.validate('title') ? "invalid" : ""}  onChange={(event)=>{this.setState({saved:false, title:event.target.value})}} value={this.state.title} id="student-title" label={Translation.get(2202 , 'Title')}/>
                        </Col>
                        <Col md={5}>
                            <FieldGroup state={!this.validate('first_name') ? "invalid" : ""} help={!this.validate('first_name') ? Translation.get(12782, "This can't be blank") : ""} onChange={(event)=>{this.setState({saved:false, first_name:event.target.value})}} value={this.state.first_name} id="student-name" label={Translation.get(579, 'First Name')}/>
                        </Col>
                        <Col md={5}>
                            <FieldGroup state={!this.validate('last_name') ? "invalid" : ""} help={!this.validate('last_name') ? Translation.get(12782, "This can't be blank") : ""} onChange={(event)=>{this.setState({saved:false, last_name:event.target.value})}} value={this.state.last_name} id="student-name" label={Translation.get(580 , 'Last Name')}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <FieldGroup state={!this.validate('email') ? "invalid" : ""} help={!this.validate('email') ? this.state.duplicateEmail == true ? "Email has been taken" : Translation.get(1033, "Invalid email") : ""} onChange={(event)=>{this.setState({saved:false, duplicateEmail:false , email:event.target.value})}} value={this.state.email} id="student-name" label={Translation.get(9 , 'Email')}/>
                        </Col>
                    </Row>
                    <Row className="strong">
                        <Col md={12}>
                            <div >
                                <lable style={{marginBottom:'10px'}}>{Translation.get(830, "Classes")}</lable><br/>
                                <Select placeholder={Translation.get(892, "Select")} isMulti={true} onChange={this.onChange.bind(this)} name="form-field-name" value={this.state.value} 
                                    options={this.props.data} className={this.props.className}/>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
             <Button onClick={this.onSave.bind(this)}>{Translation.get(657, "Save")}</Button> <Button onClick={this.props.onHide}>{Translation.get(629, "Close")}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}